<template>
    <!-- <section class=""> -->
    <div>
        <section class="hero has-background-image is-large">
            <div class="hero-body">
                <div class="hero-title">
                 <h3 class="subtitle hero-subtitle is-size-4 is-size-5-mobile">
                    Explore
                </h3>
                <h2 class="title is-size-1 is-size-2-mobile hero-title is-family-sans-serif">
                    Bike Travel Blogs
                </h2>
                <h3 class="subtitle hero-subtitle is-size-4 is-size-5-mobile">
                    by country, route, style, and more.
                </h3>
                </div>
            </div>
        </section>

        <section class="">
            <div class="my-row">
                <div class="spacer" style="height:50px"></div>
                <div class="columns light is-vcentered">
                    <div class="column is-one-third" >
                        <!-- <p class="title is-size-3" style="margin-bottom:15px">{{this.totals._posts}} posts<br></p>
                        <p class="title is-size-3" style="margin-bottom:15px">{{this.totals._sites}} blogs</p>
                        <p class="title is-size-3" style="margin-bottom:15px">{{this.totals._countries}} countries</p> -->
                        <p class="title is-size-3" style="margin-bottom:15px">1670 posts<br></p>
                        <p class="title is-size-3" style="margin-bottom:15px">227 cyclists</p>
                        <p class="title is-size-3" style="margin-bottom:15px">124 countries</p>
                        <p class="is-size-4">and growing!</p>
                    </div>
                    <div class="column" >
                        <span class="is-size-4 is-size-5-mobile" >BikeSleepBike is a directory of bike travel posts on personal blogs. Bikepacking or touring, overnight or round-the-world,
                            pavement or dirt, fast or slow, it's all welcome here.<br><router-link class="button is-medium is-primary" style="margin-top:15px" to="/share" target="_blank">
                            Submit a Blog Post</router-link>
                        </span>
                    </div>
                </div>
                <div class="spacer" style="height:50px"></div>
            </div>


           



            <!-- RECENT POSTS -->
            <div class="my-row header-panel">
            <div class="spacer" style="height:50px"></div>
            <p class="title is-size-2" style="margin-bottom:15px; line-height:1.5em;">Newest Journals</p>

            <div class="spacer" style="height:50px"></div>
            <div class="columns is-multiline is-variable is-4-desktop">
                <PageResultColumns  
                    v-for="(page, idx) in this.resultPages"
                    v-bind:key = idx 
                    :page = "page"
                    :approveMode = "false"
                    :showYear="true"
                />
            </div>
            <b-button type="is-primary is-large" style="margin-bottom:10px" v-if="!noMorePages && resultPages.length > 0" @click="nextPage">Load more</b-button>
            <div class="spacer" style="height:50px"></div>
                    </div>


            <!-- <div class="spacer" style="height:60px"></div> -->
            <div class="dark my-row">
                <div class="spacer" style="height:50px"></div>
                <h2 class="is-size-2">Explore By Region</h2>

                <div class="spacer" style="height:50px"></div>

                <div class="columns is-vcentered" >
                   <div class="column thumbnail">
                        <router-link to="/continents/Africa">
                        <figure class="image is-square">
                            <img src="https://bikesleepbike.com/thumb_africa.jpg">
                            <h3 class="overlay-text is-size-3">Africa</h3>
                        </figure>
                        
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/continents/Asia">
                        <figure class="image is-square">
                            <img src="https://bikesleepbike.com/thumb_asia.jpg">
                            <h3 class="overlay-text is-size-3">Asia</h3>
                        </figure>
                        
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/continents/Europe">
                        <figure class="image is-square">
                            <img src="https://bikesleepbike.com/thumb_europe.jpg">
                            <h3 class="overlay-text is-size-3">Europe</h3>
                        </figure>
                        </router-link>
                    </div>
                    
                </div>

                <div class="columns is-vcentered">
                    <div class="column thumbnail">
                        <router-link to="/continents/North%20America">
                        <figure class="image is-square">
                            <img src="https://bikesleepbike.com/thumb_northamerica.jpg">
                            <h3 class="overlay-text is-size-3">North America</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/continents/Oceania">
                        <figure class="image is-square">
                            <img src="https://bikesleepbike.com/thumb_oceania.jpg">
                            <h3 class="overlay-text is-size-3">Oceania</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/continents/South%20America">
                        <figure class="image is-square">
                            <img src="https://bikesleepbike.com/thumb_southamerica.jpg">
                            <h3 class="overlay-text is-size-3">South America</h3>
                        </figure>
                        
                        </router-link>
                    </div>

                </div>    

                <div class="spacer" style="height:50px"></div>
            </div>

            <div class="my-row">
                <div class="spacer" style="height:70px"></div>
                <p class="title is-size-2" style="margin-bottom:15px; line-height:1.5em;">Popular Countries</p>
                <div class="spacer" style="height:30px"></div>
                <div class="columns is-vcentered is-desktop">
                    
                    <!-- <div class="column is-one-quarter-desktop">
                        <p class="title is-size-2 is-size-3-mobile" style="margin-bottom:15px; line-height:1.5em;">Popular<br>Countries</p>
                    </div> -->
                    <div class="column">
                        <div class="columns">
                             <div class="column thumbnail">
                                <router-link to="/countries/United%20States/">
                                <figure class="image is-square">
                                    <img src="https://bikesleepbike.com/thumb_unitedstates.jpg">
                                    <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                                    <h3 class="overlay-text is-size-4 is-size-3-mobile">United States</h3>
                                </figure>
                                </router-link>
                            </div>
                            <div class="column thumbnail">
                                <router-link to="/countries/Chile/">
                                <figure class="image is-square">
                                    <img src="https://bikesleepbike.com/thumb_chile.jpg">
                                    <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                                    <h3 class="overlay-text is-size-4 is-size-3-mobile">Chile</h3>
                                </figure>
                                </router-link>
                            </div>
                            <div class="column thumbnail">
                                <router-link to="/countries/Kyrgyzstan/">
                                <figure class="image is-square">
                                    <img src="https://bikesleepbike.com/thumb_kyrgyzstan.jpg">
                                    <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                                    <h3 class="overlay-text is-size-4 is-size-3-mobile">Kyrgyzstan</h3>
                                </figure>
                                </router-link>
                            </div>
                            <div class="column thumbnail">
                                <router-link to="/countries/Canada/">
                                <figure class="image is-square">
                                    <img src="https://bikesleepbike.com/thumb_canada.jpg">
                                    <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                                    <h3 class="overlay-text is-size-4 is-size-3-mobile">Canada</h3>
                                </figure>
                                </router-link>
                            </div>
                        </div>               
                        
                    </div>
                    
                    <!-- <div class="spacer" style="height:50px"></div> -->

                </div>
                <div class="spacer" style="height:40px"></div>
                <router-link to="/countries/" class="button is-size-4 is-size-5-mobile is-info" style="margin-top:10px;">See all countries</router-link>
                <div class="spacer" style="height:60px"></div>
            </div>

            <div class="dark my-row">
                <div class="spacer" style="height:70px"></div>
                <h2 class="is-size-2">Explore By Style</h2>

                <div class="spacer" style="height:50px"></div>

                <div class="columns is-vcentered">
                    
                    <div class="column thumbnail">
                        <router-link to="/style/touring/">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_touring2.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Touring</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/bikepacking/">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_bikepacking2.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Bikepacking</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/racing/">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_racing.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Racing</h3>
                        </figure>
                        </router-link>
                    </div>
                    
                </div>

                <div class="columns is-vcentered">


                    <div class="column thumbnail">
                        <router-link to="/style/pavement/">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_road.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Road</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/gravel/">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_gravel2.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Gravel</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/singletrack/">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_singletrack2.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Singletrack</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/bike%20paths/">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_bikepath.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Bike Path</h3>
                        </figure>
                        </router-link>
                    </div>


                    
                    
                </div>
                <div class="spacer" style="height:40px"></div>
                <router-link to="/styles/" class="button is-size-4 is-size-5-mobile is-info" style="margin-top:10px;  color:white">See all styles</router-link>
                <div class="spacer" style="height:40px"></div>
            </div>

            
            <div class="my-row">
                <div class="spacer" style="height:70px"></div>
                <p class="title is-size-2" style="margin-bottom:15px; line-height:1.5em;">Popular Routes</p>
                <div class="spacer" style="height:30px"></div>
                <div class="columns is-vcentered is-desktop">
                    
                    <!-- <div class="column is-one-quarter-desktop">
                        <p class="title is-size-2 is-size-3-mobile" style="margin-bottom:15px; line-height:1.5em;">Popular<br>Routes</p>
                    </div> -->
                    <div class="column">
                        <div class="columns">
                            <div class="column thumbnail">
                                <router-link to="/routes/Silk%20Road/">
                                <figure class="image is-square">
                                    <img src="https://bikesleepbike.com/thumb_silkroad.jpg">
                                    <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                                    <h3 class="overlay-text is-size-4 is-size-3-mobile">Silk Road</h3>
                                </figure>
                                </router-link>
                            </div>
                            <div class="column thumbnail">
                                <router-link to="/routes/Cairo%20to%20Cape%20Town/">
                                <figure class="image is-square">
                                    <img src="https://bikesleepbike.com/thumb_cairotocape.jpg">
                                    <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                                    <h3 class="overlay-text is-size-4 is-size-3-mobile">Cairo to Cape Town</h3>
                                </figure>
                                </router-link>
                            </div>
                            <div class="column thumbnail">
                                <router-link to="/routes/Great%20Divide%20Mountain%20Bike%20Route/">
                                <figure class="image is-square">
                                    <img src="https://bikesleepbike.com/thumb_GDMBR.jpg">
                                    <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                                    <h3 class="overlay-text is-size-4 is-size-3-mobile">Great Divide</h3>
                                </figure>
                                </router-link>
                            </div>
                            <div class="column thumbnail">
                                <router-link to="/routes/Carretera%20Austral/">
                                <figure class="image is-square">
                                    <img src="https://bikesleepbike.com/thumb_carreteraaustral.jpg">
                                    <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                                    <h3 class="overlay-text is-size-4 is-size-3-mobile">Carretera Austral</h3>
                                </figure>
                                </router-link>
                            </div>
                        </div>               
                        
                    </div>
                    <!-- <div class="spacer" style="height:50px"></div> -->

                </div>
                <div class="spacer" style="height:50px"></div>
                <router-link to="/routes/" class="button is-size-4 is-size-5-mobile is-info" style="margin-top:10px;">See all routes</router-link>
                <div class="spacer" style="height:60px"></div>
            </div>

            
            
           

            <div class="dark my-row">
                <div class="spacer" style="height:60px"></div>
                <h2 class="is-size-2">Rider Tags</h2>
                <div class="spacer" style="height:60px"></div>

                <router-link 
                v-for="tag in this.ridertags"
                    v-bind:key = "tag"
                    :to = "'/ridertags/' + tag"
                    class="ridertag button is-white is-medium"
                >
                <span>{{tag}}</span>
                </router-link>
                <div class="spacer" style="height:50px"></div>
                <div>
                    <router-link to="/ridertags/" class="button is-size-4 is-size-5-mobile is-info is-medium" style="margin-top:10px; color: white">See all tags</router-link>
                </div>
                <div class="spacer" style="height:70px"></div>
            </div>

            <div class="my-row container">
                <div class="spacer" style="height:40px"></div>
                <!-- <h2 class="is-size-2">Books</h2>
                <div class="spacer" style="height:60px"></div> -->

                <BooksList  
                    :anchor="'books'"
                    :heading = "'Bike Travel Books'"
                    :num = "8"
                    :isMinimal = "true"
                />

                <!-- <div class="spacer" style="height:50px"></div> -->
                <!-- <div>
                    <router-link to="/books/" class="button is-size-4 is-size-5-mobile is-info is-medium" style="margin-top:10px; ">See all books</router-link>
                </div> -->
                <div class="spacer" style="height:70px"></div>
            </div>



             <!-- FEATURED COLLECTIONS -->
            <div class="my-row header-panel">
                <div class="spacer" style="height:50px"></div>
                <div class="columns is-vcentered is-centered" >
                    <div class="column thumbnail is-half-desktop is-full-mobile">
                        <div style="max-width:500px; margin-left:auto; margin-right:auto">
                            <h2 class="title is-size-2">Featured Collection</h2>
                            <p class="is-size-4 is-size-5-mobile"> Celebrating a different facet of bicycle travel each month.</p><br>
                        </div>
                    </div>
                   <div class="column thumbnail is-half-desktop is-full-mobile">
                        <router-link to="/feature/adventurecycling">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_adventurecycling.jpg">
                            <h3 class="overlay-text is-size-2 is-size-4-mobile">Adventure Cycling Association</h3>
                        </figure>
                        
                        </router-link>
                    </div>                    
                </div>
                <div class="spacer" style="height:30px"></div>
                <div class="is-size-5" style="text-align:center; ">
                    <span style="font-weight:bold">Previous Featured Collections: </span>
                    <div class="spacer" style="height:20px"></div>
                    <!-- <router-link to="/feature/desert">Deserts</router-link> -->
                    <div class="columns is-vcentered is-centered" >
                        <div class="column thumbnail is-one-fifth">
                            <router-link to="/feature/desert">
                                <figure class="image is-16by9" >
                                    <img src="https://bikesleepbike.com/thumb_desert.jpg">
                                    <h3 class="overlay-text is-size-3 is-size-3-mobile" style="color:white">Deserts</h3>
                                </figure>
                            </router-link>
                        </div>
                        <div class="column thumbnail is-one-fifth">
                            <router-link to="/feature/couples">
                                <figure class="image is-16by9" >
                                    <img src="https://bikesleepbike.com/thumb_couples.jpg">
                                    <h3 class="overlay-text is-size-3 is-size-3-mobile" style="color:white">Couples</h3>
                                </figure>
                            </router-link>
                        </div>
                    </div>
                <div class="spacer" style="height:50px"></div>
                </div>
            </div>


        </section>   



    </div>
</template>

<script>
import BooksList from '@/components/BooksList';
import PageResultColumns from '@/components/PageResultColumns';

export default {
  name: 'Home',
  components: {BooksList, PageResultColumns},
  data () {
    return {
        totals: {},
        ridertags: ['solo female', 'solo male', 'couple', 'with kids', 'fat bikes', 'over 65', 'diversify outdoors', 'LGBTQ+'],

       // recent post stuff copied from Route component
        currentQuery: undefined,
        lastVisibleResult: undefined,
        currentQuery: undefined,
        queryLimit: 9,
        resultPages: []
    }
  },
  computed: {
  
  },
  methods: {
   fetchRecentPages(fieldname, querytype, value) {
            if (this.$debug) {console.log("DEBUG: In function fetchRecentPages on Home page");}
            if (value != "") { // GET FILTERED
                this.$analytics.logEvent('fetch_results', { type: 'style', value: value});
                this.isLoading = true;
                var that = this;
                var result = [];
                this.noMorePages = false;
                this.lastVisibleResult = undefined;
                this.currentQuery = this.$db.collection("pages").orderBy("added", "desc");
                this.currentQuery.limit(that.queryLimit).get()
                    .then(function(querySnapshot) {
                        querySnapshot.forEach(function(doc) {
                            // doc.data() is never undefined for query doc snapshots
                            var dataAndId = doc.data();
                            dataAndId['id'] = doc.id;
                            result.push(dataAndId);
                        
                        });
                        that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                        if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                            that.noMorePages = true;
                        }
                        that.resultPages = result;
                        that.isLoading = false;
                        if (that.$debug) {
                            console.log("DEBUG: resultPages:");
                            console.log(that.resultPages);
                        }
                    })
                    .catch(function(error) {
                        console.log("Error getting most recent pages: ", error);
                        that.isLoading = false;
                    });
            } 
    },
     nextPage() {
        if (this.$debug) {console.log("DEBUG: In function nextPage");}
        var that = this;
        var result = [];  
        // var queryLimit = this.pageSize;
        //     if (this.activeFilterCount > 0) { //override pagination if filters are being used (hack for now because firebase sucks at tag filtering)
        //         queryLimit = 1000;
        //     }
        if (this.lastVisibleResult) {
            this.noMorePages = false;
            this.currentQuery.startAfter(this.lastVisibleResult).limit(that.queryLimit).get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots
                    // console.log(doc.id, " => ", doc.data());
                    // result.push(doc.data());
                    var dataAndId = doc.data();
                    dataAndId['id'] = doc.id;
                    result.push(dataAndId);
                
                });
                // console.log("last");
                that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                    that.noMorePages = true;
                }
                that.resultPages.push(...result);
                // that.resultPages = [].concat(that.resultPages, result); // this is for loading more below
                // that.resultPages = result; // this is for replacing results with next page
                // that.showingSelected = false;
                // console.log(that.$route.path);
                // if (that.$route.path != '/d') {
                //     that.$router.push({ path: '/d'});
                // }
            })
            .catch(function(error) {
                console.log("Error getting next chunk of page results: ", error);
            });         

        } else {
            this.noMorePages = true;
        }
                
        
    },
    

  },
  metaInfo() {
        var title =  'BikeSleepBike | Bicycle Touring and Bikepacking Blogs Tagged by Place, Style, and More.';
        var description = "Explore bike travel blogs by country, route, style, and more in this directory created by and for bicycle travelers and bikepackers.";
        return {
            title: title,
           
            description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "description", content: description  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com" + this.$route.path}
            ]
            // title: 'Browse | Bike Sleep Bike',
            // description: "Find bike travel blogs"
            
        }
    },
  mounted() {
    //  this.$setTotals(this.totals);
    // this.totals = this.$getTotals();
    var that = this;
     this.$db.collection("counts").doc("totals").get()
    .then(function(doc) {
        if (doc.exists){
            if (that.$debug) {
            }
            that.totals = doc.data();
        }
    }).catch(function(error) {
        console.error("Error fetching totals: ", error);
    });
    this.fetchRecentPages();
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .my-row {
        padding: 50px;
        /* background-color:white; */
    }
    .my-row .columns {
        max-width:1500px;
        margin-left:auto;
        margin-right:auto;
    }


    .dark {
        background-color:grey;
        background-color: #0b203f;
    }
    .dark p, .dark h2, .dark h3, .dark a {
        color:white;
    }
    .dark a.button {
        color: inherit;
    }

    .thumbnail {
        /* padding: 40px; */
    }
    .thumbnail .image {
        background-color:black;
        
    }
    .thumbnail img {
        opacity:0.8;
    }
    .thumbnail img:hover {
        opacity:0.7;
    }
    .thumbnail a {
        color:white;
    }
 
    .overlay-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

    }

    .ridertag {
        display:inline-block;
        margin-right:10px;
        margin-bottom:10px;
    }
    .ridertag a {
        color:black;
    }

    .hero.has-background-image {
        /* background-color:black; */
        background-image: url(https://bikesleepbike.com/bsb_hero_image_canada.jpg);
        background-size: cover;
        background-position: center bottom;
        position:relative;
        overflow:hidden;
      /*  object-fit: fill; */
        object-position: bottom center;
        width: 100%;
        height: 600px;
        opacity: 1;
    }
    .hero-body {
        background-color: rgba(0, 0, 0, 0.25);
    }
    .hero-title {
        /* font-size:5em !important; */
        color: white !important;
        margin-top:-150px;
    }
    .hero-subtitle {
        font-size:3em;
        color:white;
        padding-top:20px;
    }

    @media screen and (max-width: 1000px) {
        .thumbnail {
            padding:10px;
        }

    }
    @media screen and (max-width: 773px) {
        .my-row {
            padding:20px;
            /* background-color:white; */
        }
        .hero.has-background-image {
            background-position: calc(100% + 900px) top; 

        }   
        .hero-title {
            /* font-size:4em !important; */
            /* color: white !important; */
            margin-top:60px;
        }
        .hero-subtitle {
            font-size:2em;
            color:white;
            max-width: 400px;
            margin-left:auto;
            margin-right:auto;
        }
        .thumbnail {
            padding:5px;
        }
      
  }

</style>


// WEBPACK FOOTER //
// src/components/Home.vue